import Client, {ApiClient} from '@/model/Client';
import {CombinedApiResponse, doApiRequest, Method, Module} from '..';
import {ApiCustomerLicense} from '@/model/CustomerLicense';
import {ApiSessionInfo} from '@/model/SessionInfo';


export enum ResourceSettings {
  Mandant = '/Mandant',
  License = '/Lizenz',
  Session = '/Session',
}

export async function getClients(filters?: { customerId?: string }, bearerToken?: string): Promise<CombinedApiResponse<Client[]>> {
  const response = await doApiRequest<ApiClient[]>({
    module: Module.Settings,
    resource: ResourceSettings.Mandant,
    method: Method.Get,
    customerId: filters?.customerId,
    bearerToken,
    useCache: true,
  });

  return [response.Data.map((c) => Client.fromApi(c)), response.CountAll];
}

export async function getLicences(): Promise<CombinedApiResponse<ApiCustomerLicense[]>> {
  const response = await doApiRequest<ApiCustomerLicense[]>({
    method: Method.Get,
    resource: ResourceSettings.License,
    module: Module.Settings,
  });

  return [response.Data, response.CountAll];
}

export async function getSessionInfo(customerId?: string, bearerToken?: string, client?: number): Promise<ApiSessionInfo | null> {
  const response = await doApiRequest<ApiSessionInfo[]>({
    module: Module.Settings,
    resource: ResourceSettings.Session,
    method: Method.Get,
    bearerToken,
    customerId,
    allowBeforeAuth: false,
    client,
    expand: {
      Bediener: null,
      Mandant: null,
      Freischaltung: null,
    },
    one_shot: true,
  });

  return response.Data.find(() => true) ?? null;
}
